/**
* @summary - Component that Provides PPM Planner functionality
* @autor vengateshwaran k
* @since 2024-05-30
*/
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {
  Box
} from "@mui/material";
import Tab from '@mui/material/Tab';
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PremitiveMaintenanceRepository from "../../api/repositories/premitiveMaintenanceRepository";
import { BreadcrumbBar } from "../../assets/styled-components/breadcrumbBar";
import { getFacilityId, getcompanyId } from '../../utility/tokenUtility';
import PageLoader from "../commoncomponents/PageLoader";
import PageTitle from "../commoncomponents/PageTitle";
import PDMCreate from './PDMCreate';
import PDMShowSchedule from './PDMShowSchedule';
function PredictiveMaintenanceMain() {
  const [value, setValue] = useState('1');
  const [year, setYear] = useState();
  const [serviceType, setServiceType] = useState();
  const [predictiveId, setPredictiveId] = useState();
  const [assetNo, setAssetNo] = useState();
  const [taskCode, setTaskCode] = useState();
  const [mode, setMode] = useState();
  const [changeHeaderAndButtonName, setChangeHeaderAndButtonName] = useState(false);
  const pageLoading = useRef(false);
  const facilityId = getFacilityId();
  const companyId = getcompanyId();
  const handleChange = async (event, newValue) => {
    try {
      if (mode === 'create' || (mode === 'edit' || mode === "view") && predictiveId != undefined && newValue == 1) {
        let rowData;
        if (mode === 'create') {
          setChangeHeaderAndButtonName(true);
        }
        if (predictiveId != undefined) {
          setValue(newValue);
          if ((mode === 'create' || mode === "edit") && newValue == 1) {
            pageLoading.current = true;
            if (serviceType?.label === 'FEMS') {
              rowData = await PremitiveMaintenanceRepository.getPDMListForMainPage(predictiveId);
            } else {
              rowData = await PremitiveMaintenanceRepository.getBemsPDMListForMainPage(predictiveId);
            }
            if (rowData != undefined) {
              navigate("/predictiveMaintenance/register", {
                state: { ...rowData?.data[0], readOnlyEdit: true, mode: "edit", service: serviceType?.label, changeHeaderAndButtonName: mode === 'edit' ? false : true },
              });
            }
          }
        } else {
          setValue(newValue);
        }
      } else if ((mode === 'edit' || mode === 'view') && newValue == 2) {
        setValue(newValue);
      }
    } catch (e) {
      console.error(e);
    } finally {
      pageLoading.current = false;
    }
  };
  const navigate = useNavigate();
  const handleHomeClick = () => {
    navigate('/dashboard'); // Adjust the path as needed
  };
  return (
    <>
      <PageLoader open={pageLoading.current} />
      <BreadcrumbBar>
        <Box sx={{ display: "inline-flex", gap: 1.25, alignItems: "center" }}>
          <PageTitle
            isEdit={mode === "edit"}
            isView={mode === "view"}
            editTitle={changeHeaderAndButtonName ? "Create Predictive Maintenance" : "Edit Predictive Maintenance"}
            viewTitle={"View Predictive Maintenance"}
            title={"Create Predictive Maintenance"} />
        </Box>
      </BreadcrumbBar>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="asset-record" variant="scrollable" scrollButtons="auto">
            <Tab label="Predictive Maintenance" value="1" />
            <Tab label="Show the Schedule" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <PDMCreate
            predictiveId={predictiveId}
            assetNoForShowSchedule={(item) => setAssetNo(item)}
            taskCodeForShowSchedule={(item) => { setTaskCode(item) }}
            companyId={companyId}
            facilityId={facilityId}
            handleServiceType={(item) => setServiceType(item)}
            setPredictiveId={(item) => setPredictiveId(item)}
            selectedYear={(item) => setYear(item)}
            selectedServiceType={serviceType}
            getMode={(item) => setMode(item)} />
        </TabPanel>
        <TabPanel value="2">
          <PDMShowSchedule
            assetdeatils={assetNo}
            taskCode={taskCode}
            predictiveId={predictiveId}
            companyId={companyId}
            facilityId={facilityId}
            year={year}
            serviceType={serviceType} />
        </TabPanel>
      </TabContext>
    </>
  );
}
export default PredictiveMaintenanceMain;
